import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from "prop-types"
import i18n from 'i18n/index.js'
import Post from "components/posts/Post";
import { fetchWithLocale } from "components/utils/Api.jsx";
function Posts(props){
  
  const [last_post, setLastPost] = useState({});
  const [posts, setPosts] = useState([]);
  

  useEffect(() => {
    get_posts();
  }, []);

  useEffect(() => {
  }, [last_post]);

  function get_posts(){
    return fetchWithLocale(`posts.json`)
      .then(response => response.json())
      .then(json => {
        setLastPost(json.data.last_post)
        setPosts(json.data.posts)
      }
      )
      .catch(error => console.log(error));
  }
  return (

        
        <section className="posts-blog">
          <header><h1>{I18n.t('blog.travel_nature_growth')}</h1></header>
          {last_post && 
            <section className="first-post-grid-container">
              <section className="first-post-image">
                <figure>
                  <a href={last_post.url} title="View Details" target="_blank" rel="noopener noreferrer">
                    <img className="lazyload" 
                    src={last_post.cover_f}
                    data-original={last_post.cover_f}/>
                  </a>
                </figure>
                <div className="first-post-info">
                    <p className="zone h7">{last_post.label}</p>
                    <h3><a href={last_post.url} title="View Details" target="_blank" rel="noopener noreferrer">{last_post.title}</a></h3>
                    <p className="subtile h5">
                        {last_post.subtitle}
                    </p>
                    <p className="author h7">
                        <strong>{last_post.author_name}</strong> | {last_post.author_sm}
                    </p>
                    <p className="date h7">
                        {last_post.created_at_f}
                    </p>
                </div>
              </section>
            </section>
          }

          {posts && 
            <section className="posts-grid-container">
              {posts.map((post) => {
                  const labelId = `post-label-${post.id}`;
                  return (
                    <Post 
                      key={labelId}
                      post={post}
                    />
                  );
              })}
            </section>
          }
        </section>

  
  );
}

export default Posts